module.exports = __webpack_public_path__ + "img/Business_SVG.f14e515c.svg";